import api from '@pray/shared/utils/api';

import type { GetWorkflowListsResponse } from './data/response';

/**
 * Get available lead campaigns and donation funds for workflow automations
 * @param artistId - The ID of the artist
 * @returns Promise with available lead campaigns and funds
 */
export async function getWorkflowLists(artistId: string): Promise<GetWorkflowListsResponse> {
  if (!artistId) {
    throw new Error('Artist ID is required');
  }

  const url = `/web/studio/artists/${artistId}/workflow-lists`;
  const response = await api.executeGetRequest<GetWorkflowListsResponse>(url);

  return response.data;
}
